import { setup, assign } from 'xstate';
import { ObjectNode } from '@ad3d/schemas';

export type SplatTool = 'select' | 'translate' | 'rotate' | 'scale';

export type SplatContext = {
  activeTool: SplatTool;
  node: ObjectNode | null;
  error: string | null;
};

export type SplatEvent = 
  | { type: 'SPLAT.LOADED' }
  | { type: 'SPLAT.ERROR'; error: string }
  | { type: 'SPLAT.SET_TOOL'; tool: SplatTool }
  | { type: 'SPLAT.LOAD'; node: ObjectNode };

export const splatMachine = setup({
  types: {
    context: {} as SplatContext,
    events: {} as SplatEvent,
    input: {} as ObjectNode | null,
    children: {} as {
      loadSplat: 'loadSplatActor';
    }
  },
  actors: {
    loadSplatActor: {} as any // Implemented by the app
  }
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5SwA4BsCGAXAdGg9hhAJYB2UAxAMoAKAMgIIAqOdA8gwCICinA2gAYAuolAp8sYlmL5SokAA9EAJgEBGHAA4A7AIHK12tQFYALAYBs2gDQgAnolPHtONQICcF1e4+mvAZgBfQNtUTFwCIjJKWkYWbgAlBLYEwREkEHFJaVl5JQRDDQs1f2MzZXcS91Ntf1sHAotTHAF-U39NU3dNd21lY01jYND0bDxCEnJqemZWDn5heSypGTkM-LVNHCb1ZybS1TU1ZXrEM2NXYzVPNVMnNQtjZWGQMLHiCDQwabicKm4mAB9JhsNh0NJLCQrXLrRBtDTuTz+CyIiqaKqnBD9FyeUwCYzVR4onQvN64D5fH6zdhcCEZZY5NagDaVHAE7TufzuZR+VTKfwnewqCwCHCmHRdYwCLqDfqk0a4MAAJyV+CVVJYNIW6TEUMZeUQ1w07M53N5+gFmKsbPRym0XQqBO5QxepHwEDg8jJkOyqwNCAAtP0tp1NOoLFZjE13MZMQHrjhKjpVB0zGGzNp5eFxlFyD7oUzFIgA80HoNNJ0OfafNdMUbE54epp-McmqoLFn3p8wPn9bDAwZRaHw5Ho7GhQVWYiUQ83AJOjzO4qVWre37+6VmpV2h1uQY7hY61K2dV+Z0BWiLJpgsEgA */
  id: 'splat',
  initial: 'loading',
  context: ({ input }) => ({
    activeTool: 'select',
    node: input,
    error: null
  }),
  states: {
    loading: {
      entry: ({ context }) => console.log('Splat Machine: Loading...', context.node?.asset_ref.url),
      invoke: {
        id: 'loadSplat',
        src: 'loadSplatActor',
        input: ({ context }: { context: SplatContext }) => ({ url: context.node?.asset_ref.url }),
        onDone: {
          target: 'idle',
          actions: () => console.log('Splat Machine: Loaded')
        },
        onError: {
          target: 'error',
          actions: assign({
            error: ({ event }) => String(event.error)
          })
        }
      },
      on: {
        'SPLAT.LOAD': {
          target: 'loading',
          actions: assign({
            node: ({ event }) => event.node,
            error: null
          })
        }
      }
    },
    idle: {
      entry: () => console.log('Splat Machine: Idle'),
      on: {
        'SPLAT.SET_TOOL': {
          actions: assign({
            activeTool: ({ event }) => event.tool
          })
        },
        'SPLAT.LOAD': {
          target: 'loading',
          actions: assign({
            node: ({ event }) => event.node,
            error: null
          })
        }
      }
    },
    error: {
      entry: ({ context }) => console.error('Splat Machine Error:', context.error),
      on: {
        'SPLAT.LOAD': {
          target: 'loading',
          actions: assign({
            node: ({ event }) => event.node,
            error: null
          })
        }
      }
    }
  }
});
